import { Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { EntrySelectField } from 'components/common/form';
import { FieldType } from 'entities/common';

import { ColumnBaseProps } from '../types';

const DataTypeColumn: React.FC<ColumnBaseProps> = ({ record }) => {
  const { t } = useTranslation();

  const fieldTypeTextMapper = React.useMemo(
    () =>
      ({
        [FieldType.formula]: t('fieldType.formula'),
        [FieldType.bool]: t('fieldType.bool'),
        [FieldType.int]: t('fieldType.int'),
        [FieldType.str]: t('fieldType.str'),
        [FieldType.datetime]: t('fieldType.datetime'),
        [FieldType.enum]: t('fieldType.enum'),
        [FieldType.percent]: t('fieldType.percent'),
      }) as Record<FieldType, string>,
    [t]
  );

  if (record.formField.custom) {
    return (
      <EntrySelectField
        textMapper={fieldTypeTextMapper}
        model={record.formField.selectModel}
      />
    );
  }

  return (
    <Typography.Text type="secondary">
      {fieldTypeTextMapper[record.formField.fieldData.dataType]}
    </Typography.Text>
  );
};

export default observer(DataTypeColumn);
